<template>
  <div class="container bg-gray">
    <!-- 未绑卡 -->
    <div class="relative" v-if="!isBind">
      <!-- <div class="tit-box">
        <div class="userinfo absolute flex-box">
          <van-image
            class="height139 round-header"
            width="50"
            height="50"
            round
            :src="userData.headimgurl"
          ></van-image>
          <div class="mar-l-37 height139 display-flex">
            <p class="text-16 flex-1">{{userData.realname}}</p>
          </div>
        </div>
      </div>-->
      <div class="tit-box1">
        <div class="userinfo1 flex-box-normal">
          <img
            class="height139 headimg"
            :src="userData.headimgurl||'../../../assets/images/temp/avatar.png'"
            alt
          />
          <div class="lineheight139 in-text">
            <p class="text-16 text">{{userData.nickname}}</p>
          </div>
          <div class="height139 lineheight139">
            <!-- <img class="icon48" src="../../../assets/images/common/qrcode.png" alt /> -->
          </div>
        </div>
      </div>
      <div class="flex-space-around absolute userinfo-spl text-white text-center width100b">
        <div @click="handleclick(4)">
          <p>{{userData.cardNum}}</p>
          <p>优惠券</p>
        </div>
        <div @click="handleclick(0)">
          <!-- ERP数据 目前为0  -->
          <p>{{carMsg.acctBalance || 0}}</p>
          <p>余额</p>
        </div>
        <div @click="handleclick(1)">
          <!-- @click="go('/package')" -->
          <!-- ERP数据 目前为0 页面 /package  -->
          <p>{{carMsg.apcCount || 0}}</p>
          <p>套餐</p>
        </div>
      </div>
      <div class="bg-white mar-auto car-bd flex-bind" @click="go('/addCar?type=1')">
        <span class="pad-l-45 text-13 text-500">点击此处进行车辆绑定</span>
        <img class="icon-right pad-r-45" src="../../../assets/images/common/icon-right.png" alt />
      </div>
    </div>
    <!-- 已绑卡 -->
    <div class="relative" v-else>
      <div class="tit-box1">
        <div class="userinfo1 flex-box-normal">
          <img
            class="height139 headimg"
            :src="userData.headimgurl||'../../../assets/images/temp/avatar.png'"
            alt
          />
          <div class="lineheight139 in-text">
            <p class="text-16 text">{{userData.nickname}}</p>
          </div>
          <div class="height139 lineheight139">
            <!-- <img class="icon48" src="../../../assets/images/common/qrcode.png" alt /> -->
          </div>
        </div>
      </div>
      <div class="flex-space-around absolute userinfo-spl text-white text-center width100b">
        <div @click="go('/VipCard')">
          <p>{{userData.cardNum}}</p>
          <p>优惠券</p>
        </div>
        <div @click="handleclick(0)">
          <!-- ERP数据 目前为0  -->
          <p>{{carMsg.acctBalance || 0}}</p>
          <p>余额</p>
        </div>
        <div @click="handleclick(1)">
          <!-- @click="go('/package')" -->
          <!-- ERP数据 目前为0 页面 /package  -->
          <p>{{carMsg.apcCount || 0}}</p>
          <p>套餐</p>
        </div>
      </div>
      <div class="bg-white mar-auto car-bd1 display-flex1" @click="go('/bindCar')">
        <div class="pad-l-45 text-12 flex-1 mar-auto-c carmsg">
          <!-- ERP数据 目前为0 页面 /package  -->
          <p>
            <span>我的车型：</span>
            <span class="carinfo">{{carMsg.carModel}}</span>
          </p>
          <!-- ERP数据 目前为0 页面 /package  -->
          <p>
            <span>行驶里程：</span>
            <span>{{carMsg.carMiles?`${carMsg.carMiles} km`:''}}</span>
          </p>
        </div>
        <div class="flex-1 mar-auto-c text-center checkcar">
          切换车辆
          <img class="icon-right" src="../../../assets/images/common/icon-right.png" alt />
        </div>
      </div>
    </div>
    <div class="data-form mar-t-37">
      <div class="car-box">
        <p class="text-14 text-500 pad-l-45 pad-t-16">车辆档案</p>
        <div class="flex-space-around text-center mar-t-27">
          <!-- @click="go('/carRecord')" -->
          <!-- ERP数据 目前为0 页面 /carRecord  -->
          <div class="flex-baseline" @click="handleclick(2)">
            <img class="height61" src="../../../assets/images/common/car-histroy.png" alt />
            <p class="text-12">养车记录</p>
          </div>
          <!-- @click="go('/condition')" -->
          <!-- ERP数据 目前为0 页面 /condition  -->
          <div class="flex-baseline" @click="handleclick(3)">
            <img class="height72" src="../../../assets/images/common/car-detection.png" alt />
            <p class="text-12">车况检测</p>
          </div>
          <div class="flex-baseline" @click="handleclick(5)">
            <img class="height67" src="../../../assets/images/common/car-appointment.png" alt />
            <p class="text-12">我的预约</p>
          </div>
          <div class="flex-baseline" @click="handleclick(6)">
            <img class="height75" src="../../../assets/images/common/car-order.png" alt />
            <p class="text-12">我的订单</p>
          </div>
        </div>
      </div>
      <div class="car-box1 mar-t-27">
        <p class="text-14 text-500 pad-l-45 pad-t-45">自主服务</p>
        <div class="text-center mar-t-16">
          <van-row justify="space-around" type="flex">
            <van-col span="4">
              <!-- // 一键救援 http://clubber.s9090.com/xmz-cluber-web/static/weixin_menu/help.html
    // 爱车股价 http://clubber.s9090.com/xmz-cluber-web/service/serviceAction_carvalue.action
              // ZOOMM http://zoomm.com.cn-->
              <div @click="handleclick(7)">
                <img class="height132" src="../../../assets/images/common/car-save.png" alt />
                <p class="text-12">一键救援</p>
              </div>
            </van-col>
            <van-col span="4">
              <div @click="handleclick(8)">
                <img class="height132" src="../../../assets/images/common/car-evaluate.png" alt />
                <p class="text-12">爱车估价</p>
              </div>
            </van-col>
            <van-col span="4">
              <div @click="handleclick(9)">
                <img class="height132" src="../../../assets/images/common/car-tags.png" alt />
                <p class="text-12">挪车贴</p>
              </div>
            </van-col>
            <van-col span="4">
              <div @click="handleclick(11)">
                <img class="height132" src="../../../assets/images/common/car-us.png" alt />
                <p class="text-12">关于我们</p>
              </div>
            </van-col>
            <!-- <van-col span="4">
              <div @click="handleclick(10)">
                <img class="height53" src="../../../assets/images/common/car-promote.png" alt />
                <p class="text-12">推广收益</p>
              </div>
            </van-col> -->
          </van-row>
        </div>
        <div class="text-center mar-t-16">
          <van-row type="flex" justify="space-between">
            <van-col span="6">
              <div @click="handleclick(12)">
                <img class="height132" src="../../../assets/images/common/zoom.png" alt />
                <p class="text-12">ZOOMM</p>
              </div>
            </van-col>
            <!-- <van-col span="6">
              <div @click="handleclick(13)">
                <img class="height132" src="../../../assets/images/common/car-vact.png" alt />
                <p class="text-12">浏览活动</p>
              </div>
            </van-col> -->
            <van-col span="6">
              <div @click="handleAddtime">
                <img class="height132" src="../../../assets/images/common/car-xcx.png" alt />
                <p class="text-12">小程序</p>
              </div>
            </van-col>
            <van-col span="6">
              <div @click="handleclick(14)">
                <img class="height132" src="../../../assets/images/common/car-juan.png" alt />
                <p class="text-12">兑换优惠券</p>
              </div>
            </van-col>
          </van-row>
        </div>
        <!-- <div class="text-center mar-t-16">
          <van-row type="flex" justify="space-between">
            <van-col span="6">
              <div @click="handleclick(13)">
                <img class="height132" src="../../../assets/images/common/car-yhact.png" alt />
                <p class="text-12">优惠活动</p>
              </div>
            </van-col>
          </van-row>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      UserInfo: state => state.UserInfo,
      carMsg: state => state.carMsg
    })
  },
  data () {
    return {
      isBind: false, // 是否绑定
      userData: {}, // 用户数据
      loading: false, // 菊花转
      times: 0,
      addNum: 1
    };
  },
  mounted () {
    if (this.getStore('To') && this.getStore('To') === 'order') {
      this.removeStore('To');
      this.go('/order');
    } else if (this.getStore('To') && this.getStore('To') === 'Tuan') {
      this.removeStore('To');
      this.go(`/Activity/Tuan?id=${this.$route.query.id}&tuanId=${this.$route.query.tuanId}&showHelp=true`);
    }
    this.getAuth();
  },
  methods: {
    handleAddtime () {
      if (this.times > 20) {
        console.log('++', this.times, this.addNum);
        // window.eruda.init();
        if (this.addNum === 1) {
          (function () {
            var script = document.createElement("script");
            script.src = "//cdn.jsdelivr.net/npm/eruda";
            document.body.appendChild(script);
            script.onload = function () {
              window.eruda.init();
            };
          })();
          this.addNum = 2;
        }
        return;
      }
      this.times += 1;
    },
    async getCarSDK (data) {
      try {
        // if (this.carMsg.licensePlate === "浙ACAN01") {
        //   console.log(this.carMsg);
        //   return;
        // }
        console.log(this.defaultCar);
        // this.$loading("加载中");
        let result = await this.request("/user/queryCustBaseInfo", {
          carNo: this.defaultCar.carNo
          // process.env.NODE_ENV !== "development"
          //   ? this.defaultCar.carNo
          //   : "浙ACAN01" // data.userCarList[0].carNo
        });
        let carInfo = JSON.parse(result.data);
        console.log('car', carInfo);
        // this.carMsg = carInfo.custBaseInfo;
        this.$store.commit("updateCarMsg", carInfo.custBaseInfo);
        // console.log(result);
        // this.$loadingClose();
      } catch (e) {
        // this.$loadingClose();
        console.log("err", e);
        // this.$error(e.message);
      }
    },
    async handleclick (val) {
      if (val < 4) {
        if (!this.isBind) {
          // console.log("未绑定车辆");
          this.go("/addCar");
        } else {
          console.log(this.carMsg, this.carMsg.carUuid);
          if (!this.carMsg.carUuid) {
            return;
          }
          switch (val) {
            case 1:
              this.go("/package");
              break;
            case 2:
              this.go("/carRecord");
              break;
            case 3:
              this.go("/condition");
              break;
          }
        }
      } else {
        let res = await this.request("/user/user/get", {});
        // console.log(res);
        if (res.data.mobile === "" && (val === 4 || val === 5)) {
          // console.log("未绑定手机号");
          this.go("/addCar?type=5");
          return;
        }
        switch (val) {
          case 4:
            this.go("/VipCard");
            break;
          case 5:
            this.go("/reserve");
            break;
          case 6:
            this.go("/order");
            break;
          case 7:
            this.fullLocationGo(
              "http://clubber.s9090.com/xmz-cluber-web/static/weixin_menu/help.html"
            );
            break;
          case 8:
            this.fullLocationGo(
              "http://clubber.s9090.com/xmz-cluber-web/service/serviceAction_carvalue.action"
            );
            break;
          case 9:
            this.go("/carStick");
            break;
          case 10:
            this.go("/spread");
            break;
          case 11:
            this.fullLocationGo(
              "http://clubber.s9090.com/xmz-cluber-web/service/serviceAction_company.action"
            );
            break;
          case 12:
            // this.fullLocationGo("http://zoomm.com.cn");
            this.fullLocationGo("http://www.zoomm.com.cn");
            break;
          case 13:
            this.go("/ActivityRecord");
            break;
          case 14:
            this.go("/exchangeCard");
            break;
        }
      }
    },
    // 调起微信授权
    getAuth () {
      // alert(this.$store.state.code, localStorage.getItem('authToken'));
      const token = this.getStore("authToken");
      if (token) {
        console.log("有token了");
        this.initData();
      } else {
        localStorage.removeItem("isAuth");
        localStorage.setItem("now_url", this.$route.fullPath);
        this.go("/auth");
      }
    },
    // 获取数据
    async initData () {
      try {
        this.$loading("加载中");
        let result = await this.request("/user/user/get", {});
        // console.log(result);
        this.userData = result.data;
        this.defaultCar = this.userData.userCarList.filter(
          it => it.isDefault === 1
        )[0];
        console.log('asd');
        this.getCarSDK(this.userData);
        if (result.data.userCarList.length === 0) this.isBind = false;
        else this.isBind = true;
        this.$loadingClose();
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    },
    fullLocationGo (url) {
      if (url) {
        window.location.href = url;
      }
    }
    // 一键救援 http://clubber.s9090.com/xmz-cluber-web/static/weixin_menu/help.html
    // 爱车股价 http://clubber.s9090.com/xmz-cluber-web/service/serviceAction_carvalue.action
    // ZOOMM http://zoomm.com.cn
    // 关于我们 http://clubber.s9090.com/xmz-cluber-web/service/serviceAction_company.action
  }
};
</script>

<style lang="less" scoped>
.tit-box {
  background-image: url("../../../assets/images/temp/bg-small.png");
  height: 3.55rem;
  background-size: 100% 100%;
}

.tit-box1 {
  background-image: url("../../../assets/images/temp/accountBg.png");
  height: 5.8rem;
  background-size: 100% 100%;
}
.display-flex {
  flex: 1;
}
.userinfo {
  color: #fff;
  width: 85%;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
}
.text {
  white-space: nowrap;
  padding-left: 15px;
  text-align: left;
}
.in-text {
  flex: 1;
}
.userinfo1 {
  color: #fff;
  width: 85%;
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  .headimg {
    border-radius: 0.24rem;
  }
}

.userinfo-spl {
  top: 3.24rem;
}
.flex-box {
  display: flex;
  align-items: center;
}
.round-header {
  height: 1.39rem;
  border-radius: 100%;
}
.height139 {
  height: 1.39rem;
}

.lineheight139 {
  line-height: 1.39rem;
}

.icon-right {
  height: 0.29rem;
  padding-left: 0.1rem;
}

.icon48 {
  height: 0.48rem;
}

.car-bd {
  position: absolute;
  bottom: -0.4rem;
  width: 85%;
  left: 50%;
  transform: translateX(-50%);
  height: 1.47rem;
  box-shadow: 0rem 0rem 0.27rem 0rem rgba(210, 210, 210, 0.5);
  border-radius: 0.13rem;
  line-height: 1.47rem;
}

.car-bd1 {
  position: absolute;
  bottom: -0.4rem;
  width: 85%;
  left: 50%;
  transform: translateX(-50%);
  height: 1.47rem;
  box-shadow: 0rem 0rem 0.27rem 0rem rgba(210, 210, 210, 0.5);
  border-radius: 0.13rem;
}

.height147 {
  height: 1.47rem;
  line-height: 1.47rem;
}

.car-box {
  height: 2.83rem;
  background: #fff;
}

.car-box1 {
  background: #fff;
  box-shadow: 0px 0px 0.3rem 0px rgba(210,210,210,0.5);
  border-radius: 0.15rem;
  padding-bottom: 0.45rem;
}
.flex-bind {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pad-r-45 {
  padding-right: 30px;
}
.carmsg {
  p {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    span {
      & + span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.carinfo {
  width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>